module.exports = __webpack_public_path__ + "static/media/TICK1.d2433093.svg";